import axios from '../lib/axios';
import {
  CREATE_BANNER,
  CREATE_BANNER_COUPON,
  CREATE_BANNER_PROMOTION,
  FIND_MANY_BANNER,
  FIND_MANY_BANNER_PROMOTION_AND_COUPON,
  UPDATE_BANNER,
  UPDATE_BANNER_COUPON,
  UPDATE_BANNER_PROMOTION,
} from '../lib/endpoints/advertise';

interface BannerSlideProps {
  page?: number;
  limit?: number;
  merchant?: string;
  type?: string;
}

interface BannerPromotionAndCouponProps {
  page?: number;
  limit: number;
  type?: string;
}

export interface InputCreateBannerSlide {
  merchant?: string;
  productId?: string;
  promotionTagId?: string;
  subCategoryId?: string;
  isActive?: boolean;
  image?: File;
  type?: string;
  link?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
}

export interface InputCreateBannerPromotionAndCoupon {
  merchant: string;
  promotionTagId?: string;
  isActive?: boolean;
  image?: File;
  type?: string;
  link?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
}

export interface InputUpdateBannerPromotionAndCoupon {
  image?: File;
  startDate?: string;
  endDate?: string;
  isActive?: boolean;
}

export interface InputUpdateBannerSlide {
  merchant?: string;
  image?: File;
  link?: string;
  description?: string;
  isActive?: boolean;
  startDate?: string;
  endDate?: string;
}

export const getAllBannerSlideService = async ({ page, limit, type }: BannerSlideProps) => {
  try {
    const queryParams: Record<number, string> = {
      ...(page !== undefined ? { page: page } : {}),
      ...(limit !== undefined ? { limit: limit } : {}),
    };

    const queryString = new URLSearchParams(queryParams).toString();
    const res = await axios.post(
      `${FIND_MANY_BANNER}?${queryString}`,
      {
        type: type,
      },
      {
        headers: {
          'Accept-Language': 'lo',
        },
      }
    );
    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBannerPromotionAndCouponService = async ({
  limit,
  page,
}: BannerPromotionAndCouponProps) => {
  try {
    const queryParams: Record<number, string> = {
      ...(page !== undefined ? { page: page } : {}),
      ...(limit !== undefined ? { limit: limit } : {}),
    };
    const queryString = new URLSearchParams(queryParams).toString();
    const res = await axios.post(`${FIND_MANY_BANNER_PROMOTION_AND_COUPON}?${queryString}`);
    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const createBannerSlideService = async (input: InputCreateBannerSlide) => {
  try {
    const formData = new FormData();
    for (const [key, value] of Object.entries(input)) {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else if (value) {
        formData.append(key, value);
      }
    }
    await axios.post(CREATE_BANNER, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};

export const createBannerPromotionService = async (input: InputCreateBannerPromotionAndCoupon) => {
  try {
    const formData = new FormData();
    for (const [key, value] of Object.entries(input)) {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else if (value) {
        formData.append(key, value);
      }
    }
    await axios.post(CREATE_BANNER_PROMOTION, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};

export const createBannerCouponService = async (input: InputCreateBannerPromotionAndCoupon) => {
  try {
    const formData = new FormData();
    for (const [key, value] of Object.entries(input)) {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else if (value) {
        formData.append(key, value);
      }
    }
    await axios.post(CREATE_BANNER_COUPON, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};

export const updateBannerSlideService = async (id: string, input: InputUpdateBannerSlide) => {
  try {
    const formData = {
      image: input.image,
      startDate: input.startDate,
      endDate: input.endDate,
      isActive: input.isActive,
    };
    await axios.patch(`${UPDATE_BANNER}${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};

export const updateBannerPromotionService = async (
  id: string,
  input: InputUpdateBannerPromotionAndCoupon
) => {
  try {
    const formData = {
      image: input.image,
      startDate: input.startDate,
      endDate: input.endDate,
      isActive: input.isActive,
    };
    await axios.patch(UPDATE_BANNER_PROMOTION + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};

export const updateBannerCouponService = async (
  id: string,
  input: InputUpdateBannerPromotionAndCoupon
) => {
  try {
    const formData = {
      image: input.image,
      startDate: input.startDate,
      endDate: input.endDate,
      isActive: input.isActive,
    };
    await axios.patch(UPDATE_BANNER_COUPON + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });
  } catch (error) {
    throw error;
  }
};
